import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminPrivateComponent = () => {
  const { type } = useSelector((state) => {
    return state.ERPAdminReducer;
  });

  return type === "admin" ? <Outlet /> : <Navigate from='*' to='/404' />;
};

export default AdminPrivateComponent;
